<template>
  <div
    class="section"
  >
    <img
      :src="shift.doctorPhotoUrl"
      alt=""
      class="image--circle image--size-x-3"
    >
    <div class="column--central">
      <div class="mv2">
        {{ shift.doctor }}
      </div>
      <div class="fs1 fc--secondary mv1">
        {{
          (shift.substitute==='無' || shift.substitute===shift.doctor)
            ? '': `代${shift.substitute}`
        }} 醫師
      </div>
    </div>
    <template v-if="shift.division === '小兒科'">
      <div
        class="column--central row__span--2"
      >
        <div class="row--central mv1">
          <div class="label bc--default ph3 pv1 fs1 mh1">
            {{ shift.room }}
          </div>
        </div>
        <div class="fs1 fc--secondary mv1">
          {{ shift.timeSlotName }}
          {{ shift.startCheckInTime }} - {{ shift.endCheckInTime }}
        </div>
      </div>
      <div
        v-if="shift.canMakeAppointment"
        class="column--central"
      >
        <div class="row--central mv1">
          <div class="">
            {{ shift.numAppointments }}
          </div>
        </div>
        <div class="fs1 fc--secondary mv1">
          掛號人數
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="column--central"
        :class="{
          'row__span--3': shift.canMakeAppointment,
          'row__span--2': !shift.canMakeAppointment
        }"
      >
        <div class="row--central mv1">
          <div class="label bc--default ph3 pv1 fs1 mh1">
            {{ shift.room }}
          </div>
        </div>
        <div class="fs1 fc--secondary mv1">
          {{ shift.timeSlotName }}
          {{ shift.startCheckInTime }} - {{ shift.endCheckInTime }}
        </div>
      </div>
    </template>
    <div
      class="column--central"
      v-if="!shift.canMakeAppointment"
    >
      <div class="fs1 fc--primary">
        額滿
      </div>
    </div>
    <div class="column--central">
      <div
        v-if="hasButton"
        class="circle circle--size-2 circle--secondary row--central"
      >
        <font-awesome-icon
          v-if="shift.canMakeAppointment"
          :icon="['fas', 'chevron-right']"
          class="fs1"
        />
        <font-awesome-icon
          v-else-if="!shift.canMakeAppointment"
          :icon="['fas', 'user-slash']"
          class="fs1"
        />
        <!-- //todo 不可以預約的 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
